export enum ActionEnum {
  addProduct,
  changeProduct,
}
